type TOpen = React.Dispatch<React.SetStateAction<boolean>>;

export const handleOpen = (setOpenFunction: TOpen) => {
  setOpenFunction(true);
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
};

export const handleClose = (setOpenFunction: TOpen) => {
  setOpenFunction(false);
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
};
